export const buildSectionProgressId = (moduleId: string, sectionId: string) => `${moduleId}::${sectionId}`;

